<template>
  <div>
      {{ label ? $t(label).concat(': ') : ''}}
    <v-layout wrap style="width:100px;" align-center>
      <v-flex xs6
        style="border-style: solid;border-width: 1px;border-color:#CCC;border-radius: 15px 0 0 4px;"
        :style="{ 'background-color' : selectedBgColor}"
        @click="showBG = !showBG"
      >
        <center style="padding: 10px 0;">
          <v-icon :color="getOppositeColor(selectedBgColor)">mdi-format-color-fill</v-icon>
        </center>
      </v-flex>
      <v-flex xs6
        style="border-style: solid;border-width: 1px 1px 1px 0;border-color:#CCC;border-radius: 0 4px 15px 0;"
        :style="{ 'background-color' : selectedTextColor}"
        @click="showText = !showText"
      >
        <center style="padding: 10px 0;">
          <v-icon :color="getOppositeColor(selectedTextColor)">mdi-format-color-text</v-icon>
        </center>
      </v-flex>
    </v-layout>
    <v-dialog v-model="showBG" persistent max-width="330px" >
      <v-card style="padding: 10px;">
      <v-color-picker
        v-model="selectedBgColor"
        class="ma-2"
        :swatches="swatches"
        show-swatches
        mode="hexa"
      />
      <center>
        <v-btn
          @click="handleClearColor"
          style="margin-bottom:10px;"
        >
          <v-icon>mdi-water-off</v-icon> {{$t('common.clear')}}
        </v-btn>
        <v-btn
          @click="handleChangeColor"
          :color="enterpriseColor"
          dark
          style="margin-left:10px;margin-bottom:10px;"
        >
          <v-icon>mdi-close</v-icon> {{$t('common.close')}}
        </v-btn>
      </center>
    </v-card>
    </v-dialog>
    <v-dialog v-model="showText" persistent max-width="330px" >
      <v-card style="padding: 10px;">
      <v-color-picker
        v-model="selectedTextColor"
        class="ma-2"
        :swatches="swatches"
        show-swatches
        mode="hexa"
      />
      <center>
        <v-btn
          @click="handleClearTextColor"
          style="margin-bottom:10px;"
        >
          <v-icon>mdi-water-off</v-icon> {{$t('common.clear')}}
        </v-btn>
        <v-btn
          @click="handleChangeColor"
          :color="enterpriseColor"
          dark
          style="margin-left:10px;margin-bottom:10px;"
        >
          <v-icon>mdi-close</v-icon> {{$t('common.close')}}
        </v-btn>
    </center>
    </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import tinycolor from 'tinycolor2'
  export default {
    name: 'CustomColorPickerBGAndText',
    props: {
      label: {
        type: String,
        required: false,
        default: null
      },
      icon: {
        type: String,
        required: false,
        default: null
      },
      width: {
        type: String,
        required: false,
        default: null
      },
      height: {
        type: String,
        required: false,
        default: '36px'
      },
      BGColor: {
        type: String,
        required: false,
        default: null
      },
      TextColor: {
        type: String,
        required: false,
        default: null
      },
      onChangeColor: {
        type: Function,
        required: true
      }
    },
    data: () => ({
      toggle_one: null,
      showBG: false,
      showText: false,
      swatches: [
        ['#FF0000', '#AA0000', '#550000'],
        ['#FFFF00', '#AAAA00', '#555500'],
        ['#00FF00', '#00AA00', '#005500'],
        ['#00FFFF', '#00AAAA', '#005555'],
        ['#FFFFFF', '#0000AA', '#000055'],
      ],
      selectedBgColor: null,
      selectedTextColor: null
    }),
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      }
    },
    watch: {
      BGColor (v) {
        this.selectedBgColor = v
      },
      TextColor (v) {
        this.selectedTextColor = v
      },
    },
    mounted () {
      this.selectedBgColor = this.BGColor ? this.BGColor : '#fff'
      this.selectedTextColor = this.TextColor ? this.TextColor : '#fff'
    },
    methods: {
      getOppositeColor(color){
        if (!color) return '#000'
        return tinycolor(color).isLight() ? '#000' : '#FFF'
      },
      handleChangeColor () {
        this.showBG = false
        this.showText = false
        this.onChangeColor(this.selectedBgColor, this.selectedTextColor)
      },
      handleClearColor () {
        this.selectedBgColor = null
        this.handleChangeColor ()
      },
      handleClearTextColor () {
        this.selectedTextColor = null
        this.handleChangeColor ()
      },
    }
  }
</script>